import React from "react";

// SVG recreation of the P. Jasvantrai & Co. mark.
// Anatomy (matches the scanned original):
//  - Charcoal faucet body (top-right) with handle and spout
//  - A single water droplet falling from the spout
//  - Blue gradient pipe attaching to the faucet base, sweeping LEFT,
//    curving DOWN into a U, then RIGHT, and terminating on a charcoal plinth
//  - Wrench-jaw detail where pipe meets faucet
export const LogoMark = ({ className = "h-10 w-10", variant = "color" }) => {
  const pipeFill = variant === "mono" ? "#C5A059" : "url(#pjPipeGrad)";
  const metal = variant === "mono" ? "#F8F9FA" : "#0F1218";
  const drop = variant === "mono" ? "#C5A059" : "#1E4F87";

  return (
    <svg
      viewBox="0 0 140 140"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="P. Jasvantrai & Co. logo"
      role="img"
    >
      <defs>
        <linearGradient id="pjPipeGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#5BA0DC" />
          <stop offset="45%" stopColor="#2E6FB3" />
          <stop offset="100%" stopColor="#1A4577" />
        </linearGradient>
        <linearGradient id="pjPipeShade" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.25" />
          <stop offset="100%" stopColor="#000000" stopOpacity="0.15" />
        </linearGradient>
      </defs>

      {/* === BLUE PIPE === Serpentine path: starts at faucet base (upper-right),
           sweeps left, curves down, then right to plinth (lower-right). */}
      <path
        d="M 92 44
           L 56 44
           Q 32 44 32 70
           Q 32 96 56 96
           L 92 96"
        fill="none"
        stroke={pipeFill}
        strokeWidth="14"
        strokeLinecap="butt"
        strokeLinejoin="round"
      />
      {/* subtle highlight over pipe for metallic feel */}
      <path
        d="M 92 44
           L 56 44
           Q 32 44 32 70
           Q 32 96 56 96
           L 92 96"
        fill="none"
        stroke="url(#pjPipeShade)"
        strokeWidth="14"
        strokeLinecap="butt"
        strokeLinejoin="round"
      />

      {/* === CHARCOAL PLINTH (right end of pipe) === */}
      <rect x="86" y="92" width="20" height="12" fill={metal} />

      {/* === FAUCET BODY === (right side, atop the pipe) */}
      <g fill={metal}>
        {/* top handle / cap */}
        <rect x="92" y="14" width="14" height="8" />
        <rect x="94" y="22" width="10" height="8" />
        {/* horizontal faucet body */}
        <rect x="78" y="30" width="38" height="14" />
        {/* spout step on the right */}
        <rect x="108" y="44" width="10" height="8" />
        {/* wrench-jaw detail at pipe-faucet junction */}
        <path d="M 78 30 L 86 30 L 86 38 L 92 38 L 92 44 L 78 44 Z" />
      </g>

      {/* === WATER DROPLET === falling from spout */}
      <path
        d="M 113 58
           C 113 64, 119 66, 119 60
           C 119 56, 116 53, 113 58 Z"
        fill={drop}
      />
    </svg>
  );
};

export const Wordmark = ({ className = "", small = false }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <LogoMark className={small ? "h-9 w-9" : "h-11 w-11"} />
    <div className="flex flex-col leading-none">
      <span className={`font-display tracking-wide ${small ? "text-base" : "text-lg"} text-white`}>
        P. Jasvantrai <span className="text-gold">&</span> Co.
      </span>
      <span className="font-mono text-[9px] uppercase tracking-[0.28em] text-steel-light mt-1">
        Sanitary Engineers · Licensed Plumbers
      </span>
    </div>
  </div>
);

export default LogoMark;
